import { createSelector } from "@reduxjs/toolkit";
import { SET_CLEAR_QUEUE_POPUP_SHOWING, SET_CLEAR_QUEUE_POST_OPERATION } from "../actions/clearQueueActions";

export const getClearQueuePostOperation = createSelector(
    state => state.clearQueueState,
    clearQueueState => clearQueueState.postOperation
);

export const isShowingClearQueuePopup = createSelector(
    state => state.clearQueueState,
    clearQueueState => clearQueueState.popupShowing
);

const INITIAL_STATE = {
    postOperation: undefined,
    popupShowing: false
};

export const clearQueueState = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_CLEAR_QUEUE_POST_OPERATION:
            return {...state, postOperation: action.payload};
        case SET_CLEAR_QUEUE_POPUP_SHOWING:
            return {...state, popupShowing: action.payload};
        default:
            return state;
    }
};